import { format } from "date-fns"


export const formatStartDate = (startDate: string) => {
    return format(new Date(`${startDate} 00:00:00`), 'yyyy-MM-dd')
}

export const formatEndDate = (endDate: string) => {
    return format(new Date(`${endDate} 23:59:59`), 'yyyy-MM-dd')
}